import GoTrue from 'gotrue-js'
import { ok, fail } from '@/modules/OkFail'

function useNetlifyLogin () {
	const APIUrl    = 'https://hermes.fitravel.info/.netlify/identity'
	const audience  = ''
	const setCookie = true
	const auth      = new GoTrue({ APIUrl, audience, setCookie })

	function login (email: string, password: string) {
		return auth.login(email, password, true).then(ok).catch(fail)
	}
	function confirm (token: string) {
		return auth.confirm(token, true).then(ok).catch(fail)
	}
	function signup (email: string, password: string) {
		return auth.signup(email, password, {}).then(ok).catch(fail)
	}
	function authorize (email: string) {
		localStorage.setItem('hermes-auth', JSON.stringify({ email, authorized: true }))
	}
	function isAuthorized () {
		const info = localStorage.getItem('hermes-auth')
		return JSON.parse(info ?? '{}')?.authorized ?? false
	}

	return { auth, login, confirm, signup, authorize, isAuthorized }
}

export default useNetlifyLogin